module.exports = __webpack_public_path__ + "img/tux.9f162775.png";